import * as React from "react"
import { SVGProps } from "react"
const PatientResultIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26.889} height={34} {...props}>
    <g data-name="Component 6468 \u2013 7">
      <g
        fill="none"
        stroke="#172b4d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        data-name="Group 18484"
      >
        <path
          d="M8.111 4.556H4.556A3.556 3.556 0 0 0 1 8.112v21.333a3.556 3.556 0 0 0 3.556 3.556h17.777a3.556 3.556 0 0 0 3.556-3.556V8.112a3.556 3.556 0 0 0-3.556-3.556h-3.555"
          data-name="Path 5895"
        />
        <path
          d="M8.111 1v3.556A3.556 3.556 0 0 1 11.667 1h3.556a3.556 3.556 0 0 1 3.556 3.556h0a3.556 3.556 0 0 1-3.556 3.556h-3.556a3.556 3.556 0 0 1-3.556-3.556Z"
          data-name="Path 5896"
        />
        <path d="M8.111 15.222h7.111" data-name="Path 5908" />
        <path d="M8.111 22.333h10.667" data-name="Path 5909" />
      </g>
    </g>
  </svg>
)
export default PatientResultIcon
